import React, { useState, useRef } from 'react';
import { showMessage, makeAjax, url, respStatus, formatDate } from "../../../../helpers/global_helper";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import ActionLoader from '../../../../pages/ActionLoader';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs';

const ReplyMessage = (props) => {

    // Init message data
    const InitMessage = {
        message: '',
        subject: '',
        parent_id: '',
    };

    // Set & get message data
    const editor = useRef(null);
    const [content, setContent] = useState(InitMessage);
    const [formError, setFormError] = useState({});
    const rowData = props.rowData;
    const [loaderStatus, setLoaderStatus] = useState(false);

    // Onchange editor content
    const OnchangeContent = (event) => {
        setContent({
            ...content,
            ['message']: event.target.value,
        })
    }

    // Player profile details
    const sendPlayerMessage = (event) => {
        content['subject'] = rowData.subject;
        content['parent_id'] = rowData._id;
        content['operator_id'] = rowData.operator_id;
        content['player_id'] = rowData.player_id;
        content['super_parent_id'] = rowData.super_parent_id;
        content['out_box_id'] = rowData.out_box_id;
        content['group_name'] = rowData.group_name;
        setLoaderStatus(true);
        makeAjax(url.MEMO_API.sendPlayerMessage, content, url.MEMO_MS_EXT)
            .then(response => {
                if (response.status != respStatus['SUCCESS']) {
                    setLoaderStatus(false);
                    if (response.code == 'send_email_duration_error') {
                        props.emailDuration();
                        return;
                    }
                    if (response.code != 'validation_error') {
                        showMessage(response);
                    }
                    setFormError(response.messages);
                    return;
                }
                setLoaderStatus(false);
                props.replyMsgClose()
                setContent(InitMessage)
                showMessage(response);
            })
    }

    const gotoInboxListing = (event) => {
        props.gotoInboxListing();
    }
    const parseMessage = (message) => {
        try {
            const obj = JSON.parse(message);

            // Case 1: MongoDB extended date
            if (obj.date?.$date?.$numberLong) {
            const date = new Date(parseInt(obj.date.$date.$numberLong));
            return `You received a ${obj.type?.replace('_', ' ')} on ${date.toLocaleString()}`;
            }

            // Case 2: Normal JSON with ISO date
            if (obj.date && typeof obj.date === "string") {
            const date = new Date(obj.date);
            return `You received ${obj.amount ? obj.amount : ''} for ${obj.type?.replace('_', ' ')} on ${date.toLocaleString()}`;
            }

            return message; // If JSON but not matching our formats
        } catch (e) {
            // Case 3: Not JSON → might be HTML → return directly
            return message;
        }
    };
    const parsedMessage = parseMessage(rowData?.message);
    const isHTML = /<\/?[a-z][\s\S]*>/i.test(parsedMessage);

    return (
        <div className='reply-message'>
            <h5 className="subject">{rowData.subject}</h5>
            <div className="user-profile">
                {/* <FaUser className='user-face' /> */}
                <div className="user-details">
                    <span className="username"> {rowData?.domain_name.charAt(0).toUpperCase() + rowData?.domain_name.slice(1)}</span>
                    <span className="email"> {formatDate(rowData?.created_at)}
                        </span>
                </div>
            </div>
            <div className="replyscroll">
                {isHTML ? (
                    <span className="text rplyin2" dangerouslySetInnerHTML={{ __html: parsedMessage }} />
                ) : (
                    <span className="text rplyin2">{parsedMessage}</span>
                )}
                <span className='text rplyin3'>{props.t('enjoy_the_excitement_of_playing_at')}
                    {props.t('enjoy_the_excitement_of_playing_at')} {rowData?.domain_name.charAt(0).toUpperCase() + rowData?.domain_name.slice(1)}</span>
                <span className='text rplyin4'>{props.t('thank_you')} </span>
            </div>
            {props.type &&
                <>
                    <div className="to-box">
                        <textarea className='msg-text1 mt-3' placeholder={props.t('type_here ....')} value={content.message} name='message' onChange={OnchangeContent}>
                        </textarea>
                        {formError.message ? (
                            <span className="error-msg text-danger">{formError.message[0]}</span>
                        ) : null}
                    </div>
                    <div className="back-send-btn-box d-flex mt-2 justify-content-center align-items-center gap-2" style={{color: '#732697ff'}}>
                        {/* <BsFillArrowLeftCircleFill onClick={gotoInboxListing} className='arrow-message-icon' /> */}
                        <ActionLoader label={props.t('send')} loaderClass={'send-button'} showLoader={loaderStatus} onClick={sendPlayerMessage} />
                    </div>
                </>
            }

        </div>
    )
}

ReplyMessage.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(ReplyMessage);